import React from 'react';
import {
    Chip,
    IconButton,
    Tooltip
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    DescriptionOutlined as DocumentIcon,
    Visibility as VisibilityIcon,
    ContentCopy as CopyIcon
} from '@mui/icons-material';
import styles from '../DocumentsTemplates.module.css';

const DocumentCard = ({
    template,
    onEdit,
    onDelete,
    onPreview,
    onCopy
}) => {
    const getTypeClass = (type) => {
        switch(type) {
            case 'receipt': return styles.receipt;
            case 'default':
            default: return styles.default;
        }
    };

    const getTypeLabel = (type) => {
        switch(type) {
            case 'receipt': return 'Recibo';
            case 'default':
            default: return 'Simples';
        }
    };

    const formatPreview = (content) => {
        if (!content) return '';
        
        // Remove HTML tags for preview
        const cleanContent = content.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        
        // Limit to approximately 120 characters for better preview
        if (cleanContent.length > 120) {
            return cleanContent.substring(0, 120) + '...';
        }
        
        return cleanContent;
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(template.text);
            if (onCopy) {
                onCopy(template);
            }
        } catch {}
    };

    return (
        <div className={styles.templateCard}>
            <div className={styles.cardHeader}>
                <h3 className={styles.templateName}>
                    {template.tag || template.title || 'Documento sem título'}
                </h3>
                
                <div className={styles.templateTags}>
                    <Chip
                        label={getTypeLabel(template.type)}
                        size="small"
                        className={`${styles.templateTag} ${getTypeClass(template.type)}`}
                        color="primary"
                        variant="filled"
                    />
                </div>
            </div>

            <div className={styles.templatePreview}>
                <div className={styles.previewContent}>
                    {formatPreview(template.text)}
                </div>
            </div>

            <div className={styles.cardFooter}>
                <div className={styles.cardActions}>
                    <Tooltip title="Ver preview completo">
                        <IconButton
                            size="small"
                            onClick={() => onPreview && onPreview(template)}
                            color="primary"
                        >
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Copiar conteúdo">
                        <IconButton
                            size="small"
                            onClick={handleCopy}
                            color="secondary"
                        >
                            <CopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Editar documento">
                        <IconButton
                            size="small"
                            onClick={() => onEdit && onEdit(template)}
                            color="primary"
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Excluir documento">
                        <IconButton
                            size="small"
                            onClick={() => onDelete && onDelete(template)}
                            color="error"
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default DocumentCard;